import router from '@/router'
import store from '@/store'
import OldSearch from '@/pages/OldSearch.vue'

// Update routes based in the store
export const updateRoutes = () => {
  if (store.getters['featureFlags/showOldSearch']) {
    router.addRoute({
      path: '/old-search',
      name: 'old-search',
      component: OldSearch,
    })
  }
}
